export const exportDataConstants = {
    EXPORT_DATA_STATE_SUCCESS: 'EXPORT_DATA_STATE_SUCCESS',
    EXPORT_DATA_STATE_FAILURE: 'EXPORT_DATA_STATE_FAILURE',

    EXPORT_ALL_DATA_STATE_SUCCESS: 'EXPORT_ALL_DATA_STATE_SUCCESS',
    EXPORT_ALL_DATA_STATE_FAILURE: 'EXPORT_ALL_DATA_STATE_FAILURE',

    EXPORT_DATA_CLOSE_NOTIFICATION: 'EXPORT_DATA_CLOSE_NOTIFICATION',

};